export default "__VITE_ASSET__Dt5HvNk7__"